<template>
  <div>
    <label class="radio-group-label">
      <span v-text="label" />
      <div v-if="infoTooltip" class="relative radio-group-label__tooltip-wrap">
        <img
          :src="require('dashboard/assets/icons/settings/info-icon.svg')"
          alt="Info ion"
          loading="eager"
        />
        <tooltip :text="infoTooltip" />
      </div>
    </label>
    <div class="radio-group" :data-testid="`${name}-group-test`">
      <div v-for="item in items" :key="item.id" class="radio-group-item">
        <label class="radio-group-item-label">
          <input
            class="radio-input"
            :name="`${name} -radio-input`"
            :data-testid="`${item.id}-radio-input-test`"
            type="radio"
            :checked="item.checked"
            @change="action({ ...item, checked: true })"
          />
          <span>{{ item.title }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from 'components/Tooltip';

export default {
  components: { Tooltip },
  props: {
    name: {
      type: String,
      default: 'string',
    },
    infoTooltip: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    action: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-group-label {
  margin-bottom: var(--space-smaller);
  display: flex;
  align-items: center;
  gap: 5px;

  &__tooltip-wrap {
    cursor: pointer;

    &.relative {
      position: relative;
    }

    & > div {
      visibility: hidden;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
    }
    &:hover > div {
      visibility: visible;
    }
  }
}
.radio-group {
  display: inline-block;
  margin-bottom: var(--space-small);
}
.radio-group-item {
  float: left;
  margin-right: var(--space-one);
  .radio-group-item-label {
    display: flex;
    align-items: center;
    cursor: pointer;

    .radio-input {
      margin: 0 var(--space-one) 0 0;
    }
  }
}
</style>
